import { render, staticRenderFns } from "./HomeDigitalGym.vue?vue&type=template&id=af95001e"
import script from "./HomeDigitalGym.vue?vue&type=script&lang=js"
export * from "./HomeDigitalGym.vue?vue&type=script&lang=js"
import style0 from "./HomeDigitalGym.vue?vue&type=style&index=0&id=af95001e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports